import {
  type InviteUsersReq,
  type InviteUsersRes,
  type ListUsersReq,
  type ListUsersRes,
  type ManageInvitationReq,
  type ManageInvitationRes,
  type ManageUserReq,
  type ManageUserRes,
  type RevokeInviteReq,
  type RevokeInviteRes,
  type TransferOwernshipReq,
  type TransferOwernshipRes,
  inviteUsersReqSchema,
  listUsersReqSchema,
  manageInvitationReqSchema,
  manageUserReqSchema,
  revokeInviteReqSchema,
  transferOwnershipReqSchema,
} from '../entity/api/routes/organization';
import { apiRequest } from './request';

export function getOrganizationUsersList(params: ListUsersReq['params']) {
  const req = listUsersReqSchema.parse({
    params,
    query: null,
    body: null,
  });
  return apiRequest<ListUsersRes>(`/organization/${req.params.id}/users`, 'GET', true);
}

export async function inviteUsersToOrganization(
  params: InviteUsersReq['params'],
  body: InviteUsersReq['body']
) {
  const req = inviteUsersReqSchema.parse({
    params,
    query: null,
    body,
  });
  return apiRequest<InviteUsersRes>(
    `/organization/${req.params.id}/users/invite`,
    'POST',
    true,
    req.body
  );
}

export async function transferOrganizationOwnership(
  params: TransferOwernshipReq['params'],
  body: TransferOwernshipReq['body']
) {
  const req = transferOwnershipReqSchema.parse({
    params,
    query: null,
    body,
  });
  return apiRequest<TransferOwernshipRes>(
    `/organization/${req.params.id}/users/transfer`,
    'POST',
    true,
    req.body
  );
}

export async function manageOrganizationUser(
  params: ManageUserReq['params'],
  body: ManageUserReq['body']
) {
  const req = manageUserReqSchema.parse({
    params,
    query: null,
    body,
  });
  return apiRequest<ManageUserRes>(`/organization/${req.params.id}/user`, 'POST', true, req.body);
}

export async function manageOrganizationInvitation(
  params: ManageInvitationReq['params'],
  body: ManageInvitationReq['body']
) {
  const req = manageInvitationReqSchema.parse({
    params,
    query: null,
    body,
  });
  return apiRequest<ManageInvitationRes>(
    `/organization/${req.params.id}/users/invite/manage`,
    'POST',
    true,
    req.body
  );
}

export async function revokeInvite(
  params: RevokeInviteReq['params'],
  body: RevokeInviteReq['body']
) {
  const req = revokeInviteReqSchema.parse({
    params,
    query: null,
    body,
  });
  return apiRequest<RevokeInviteRes>(
    `/organization/${req.params.id}/users/invite/revoke`,
    'POST',
    true,
    req.body
  );
}
